import { verificaEmailSchema, type VerificaEmailInput } from '@aulaviva/shared';
import { Alert, Button, OtpField, PageHeading, PasswordField } from '@aulaviva/ui';
import { zodResolver } from '@hookform/resolvers/zod';
import { useState } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { Link, useNavigate, useSearchParams } from 'react-router';
import { useReinviaCodice, useVerificaEmail } from '@/api/auth';
import { ErroreRichiesta } from '@/api/client';
import { auth } from '@/testi';

export function VerificaEmail() {
  const t = auth.verificaEmail;
  const [params] = useSearchParams();
  const email = params.get('email') ?? '';
  const avvisoNonVerificata = params.get('avviso') === 'non-verificata';
  const navigate = useNavigate();
  const verifica = useVerificaEmail();
  const reinvia = useReinviaCodice();
  const [errore, setErrore] = useState<string | null>(null);
  const [rinviato, setRinviato] = useState(false);
  const { control, register, handleSubmit, formState } = useForm<VerificaEmailInput>({
    resolver: zodResolver(verificaEmailSchema),
    defaultValues: { email, codice: '', password: '' },
  });

  async function invia(dati: VerificaEmailInput) {
    setErrore(null);
    try {
      await verifica.mutateAsync(dati);
      navigate('/', { replace: true });
    } catch (e) {
      setErrore(e instanceof ErroreRichiesta && e.status === 400 ? t.codiceErrato : e instanceof Error ? e.message : t.codiceErrato);
    }
  }

  async function gestisciRinvia() {
    setRinviato(false);
    try {
      await reinvia.mutateAsync({ email, scopo: 'verifica_email' });
      setRinviato(true);
    } catch (e) {
      setErrore(e instanceof Error ? e.message : t.codiceErrato);
    }
  }

  if (!email) {
    return (
      <>
        <PageHeading>{t.titolo}</PageHeading>
        <Alert variant="warning" title={t.emailMancante}>
          <Link to="/registrati">{t.tornaAllaRegistrazione}</Link>
        </Alert>
      </>
    );
  }

  return (
    <>
      <PageHeading subtitle={t.sottotitolo(email)}>{t.titolo}</PageHeading>
      <form onSubmit={handleSubmit(invia)} noValidate className="flex flex-col gap-6">
        {avvisoNonVerificata && !errore && !rinviato && <Alert variant="info" title={auth.accedi.emailNonVerificata} />}
        {rinviato && <Alert variant="success" title={t.rinviato} />}
        {errore && <Alert variant="error" title={errore} />}
        <input type="hidden" {...register('email')} />
        <Controller
          control={control}
          name="codice"
          render={({ field }) => (
            <OtpField label={auth.campi.codice} hint={auth.campi.aiutoCodice} value={field.value} onChange={field.onChange} onBlur={field.onBlur} error={formState.errors.codice?.message} />
          )}
        />
        <PasswordField label={auth.campi.nuovaPassword} hint={auth.campi.aiutoPassword} autoComplete="new-password" error={formState.errors.password?.message} {...register('password')} />
        <Button type="submit" variant="primary" size="lg" fullWidth loading={verifica.isPending} loadingText={t.inCorso}>
          {t.azione}
        </Button>
        <Button variant="discreet" onClick={gestisciRinvia} loading={reinvia.isPending} loadingText={t.inCorso} className="self-start">
          {t.rinvia}
        </Button>
      </form>
    </>
  );
}
